import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BaseMaterialListControllerService, BidBaseInforControllerService, FormSignProcessControllerService } from 'src/app/sdk/services';
import { Lb4ApiService } from 'src/app/shared/service/api/lb4-api.service';
import { CommonService } from 'src/app/shared/service/common/common.service';
import { BID_FORM_CONTENT } from '../../bid/constant/bid-form-content';
import { BidBaseInfo, BidItem, BidItemDetail, BidTotalItem, DataOfTabel1 } from '../../bid/interface/make-bid.interface';

@Injectable({
  providedIn: 'root'
})
export class MakeBidService {
  unit = this.translateService.instant('BidCreat.UnitItem');
  totalUnit = this.translateService.instant('BidCreat.UnitRMB');
  quantity = '1';

  submitBidSaveData = {};//保存成功的标单信息
  listOfTable1Data: DataOfTabel1[] = [];
  listOfBaseMaterialData = [];//当前条件下的BaseMaterial的数组
  allBaseMaterialData = {};//所有的BaseMaterial的数组
  initBaseMaterialData: [];//初始化的BaseMaterial的数组
  table2DataModel = {};// table2数据

  bidSaveData: BidSaveData = {};
  bidBaseInfor: BidBaseInfo = {};
  bidMaterialList: BidTotalItem = {};
  bidItem: BidItem[] = [];
  bidItemDetail: BidItemDetail[] = [];

  selectColumns = ["bigType", "middleType", "smallType", "projectName", "brandNative", "specType"];
  outputColumns = ["pn", ...this.selectColumns, "unit", "notInUnitPrice"];
  table2Columns = ["pn", ...this.selectColumns, "unit", "quantity", "notInUnitPrice", "notInTotalPrice", "remark"];
  dbName = "base_material_list";

  baseMaterialData: BidItemDetail = {};

  constructor(
    private lb4ApiService: Lb4ApiService,
    private formSignProcessService: FormSignProcessControllerService,
    private baseMaterialListControllerService: BaseMaterialListControllerService,
    private bidBaseInforControllerService: BidBaseInforControllerService,
    private message: NzMessageService,
    private commonService: CommonService,
    private translateService: TranslateService
  ) { }

  // 获取厂务工程师名字 方案出处 table1的比例
  async getInitDisplayTask(formid: string, vendorCode: string) {
    let demander = '';
    let projectOrigin = '';
    let profit = '';
    let taxRate = '';
    await this.commonService.getMaxVersion(formid).then(async res => {
      let maxVersionNum = res;
      await this.formSignProcessService.getVendorInfo({ formId: formid, version: maxVersionNum }).toPromise().then(result => {
        const vendorInfoData = result;
        // 获取厂务工程师名字
        demander = vendorInfoData['assignInfo']['assignName'];
      });

      await this.lb4ApiService.find('vendor_info',
        { where: { "vendorCode": vendorCode } }).then(vendorRes => {
          const vendorInfo = vendorRes[0];
          // 获取方案出处
          projectOrigin = vendorInfo['outsource'];
          // 获取管理费及利润比例
          profit = Number(vendorInfo['profit'].replace('%', '')) + '%';
          // 获取税率&税金比例
          taxRate = Number(vendorInfo['taxRate'].replace('%', '')) + '%';
        })
        .catch((err: any) => {
          console.log("err", err);
        });
      this.bidBaseInfor = {
        'formId': formid,
        'vendorCode': vendorCode,
        'demander': demander,
        'projectOrigin': projectOrigin,
      }
      this.bidMaterialList = {
        'formId': formid,
        'vendorCode': vendorCode,
        'profit': profit,
        'taxRates': taxRate
      }
      this.bidSaveData.bidBaseInfor = this.bidBaseInfor;
      this.bidSaveData.bidMaterialList = this.bidMaterialList;
    });
    return this.bidSaveData;
  }

  // 获取下拉选项
  async selectValueChange(obj: Object, formid: string, vendorCode: string) {
    //{ "data": value, "key": name, "value": event, "index1": index1, "index2": index2 }
    let listOfBaseMaterialData = obj['data'];
    let i = obj['index1'];
    let j = obj['index2'];
    if (obj['key'] === 'quantity') {
      listOfBaseMaterialData[i]['itemDetail'][j]['quantity'] = obj['value'];
    }
    else {
      if (obj['value'] === null) {
        // obj['value'] === null不是有select被删除,则此选择及之后的选择都会被清空
        listOfBaseMaterialData[i]['itemDetail'][j]['pn'] = "";
        const cancelIndex = this.outputColumns.indexOf(obj['key']);
        for (const eachColumn of this.outputColumns) {
          const currentIndex = this.outputColumns.indexOf(eachColumn);
          if (currentIndex >= cancelIndex) {
            listOfBaseMaterialData[i]['itemDetail'][j][eachColumn] = "";
          }
        }
        listOfBaseMaterialData[i]['itemDetail'][j]['notInTotalPrice'] = "0";
      }
      // 深拷贝以用来删除除bigType middleType smallType projectName brandNative specType外的栏位
      let filterData = JSON.parse(JSON.stringify(listOfBaseMaterialData[i]['itemDetail'][j]));
      Object.keys(filterData).forEach(key => {
        if (this.selectColumns.indexOf(key) === -1) {
          // 如果key不是可select的栏位
          filterData[key] = "";
        }
        if (filterData[key] === "" || filterData[key] === "-" || filterData[key] === null) {
          delete filterData[key];
        }
      });
      if (JSON.stringify(filterData) !== "{}") {
        await this.baseMaterialListControllerService.findMaterialData({
          dbName: this.dbName,
          body: {
            "where": filterData,
            "columns": this.outputColumns
          }
        }).toPromise().then(res => {
          listOfBaseMaterialData[i]['itemDetail'][j]['baseMaterialData'] = res;
        }).catch(e => {
          this.message.create('error', this.translateService.instant('CommonMessageTip.getDataFail'));
        });
      }
      else {
        listOfBaseMaterialData[i]['itemDetail'][j]['baseMaterialData'] = this.allBaseMaterialData;
      }
      // 如果只有pn只有一个,则把所有栏位的值直接显示出来
      if (listOfBaseMaterialData[i]['itemDetail'][j]['baseMaterialData']) {
        if (listOfBaseMaterialData[i]['itemDetail'][j]['baseMaterialData']['pn'].length === 1) {
          for (const eachColumn1 of this.outputColumns) {
            listOfBaseMaterialData[i]['itemDetail'][j][eachColumn1] = listOfBaseMaterialData[i]['itemDetail'][j]['baseMaterialData'][eachColumn1][0];
          }
        }
      }
    }
    this.handleBidItemAndDetail(listOfBaseMaterialData, formid, vendorCode);
    return {
      "bidSaveData": this.bidSaveData,
      "listOfBaseMaterialData": listOfBaseMaterialData,
    };
  }
  handleBidItemAndDetail(listOfBaseMaterialData, formid: string, vendorCode: string) {
    let bidItem = [];
    let bidItemDetail = [];
    for (const each of listOfBaseMaterialData) {
      // bidItem
      this.bidItem.push({
        'formId': formid,
        'vendorCode': vendorCode,
        'item': each['item'],
      });
      for (const eachItemDetail of each['itemDetail']) {
        if (eachItemDetail['pn']) {
          eachItemDetail['notInUnitPrice'] = eachItemDetail['notInUnitPrice'].replaceAll(/[^\d.]/g, "");
          let notInTotalPrice = '';
          if (eachItemDetail['quantity'] !== '') {
            let quantity = parseFloat(eachItemDetail['quantity']);
            let notInUnitPrice = parseFloat(eachItemDetail['notInUnitPrice']);
            notInTotalPrice = String(Number((quantity * notInUnitPrice).toFixed(2)));
            eachItemDetail['notInTotalPrice'] = notInTotalPrice;
          }
          else {
            eachItemDetail['notInTotalPrice'] = '0';
          }
          bidItemDetail.push({
            'formId': formid,
            'vendorCode': vendorCode,
            'item': each['item'],
            'pn': eachItemDetail['pn'],
            'bigType': eachItemDetail['bigType'],
            'middleType': eachItemDetail['middleType'],
            'smallType': eachItemDetail['smallType'],
            'projectName': eachItemDetail['projectName'],
            'brandNative': eachItemDetail['brandNative'],
            'specType': eachItemDetail['specType'],
            'unit': eachItemDetail['unit'],
            'quantity': eachItemDetail['quantity'],
            'notInUnitPrice': eachItemDetail['notInUnitPrice'],
            'notInTotalPrice': eachItemDetail['quantity'] === '' ? "" : notInTotalPrice,
            'remark': 'remark' in eachItemDetail ? eachItemDetail['remark'] : "",
          });
        }
      }
    }
    this.bidSaveData.bidItem = bidItem;
    this.bidSaveData.bidItemDetail = bidItemDetail;
  }

  async getHistorySaveData(formid: string, vendorCode: string, getAssignPhone: string,) {
    let historyData = [];
    let listOfBaseMaterialData = [];
    let filter = { "where": { "formId": formid, "vendorCode": vendorCode } };
    await this.bidBaseInforControllerService.findBidInformation({ "body": filter }).toPromise().then(res => {
      historyData = res[0];
      // 如果有历史数据
      if (Object.keys(historyData['bidItemDetail'][0]).length > 0) {
        if (historyData['bidBaseInfor'] === undefined) {
          this.bidBaseInfor.formId = formid;
          this.bidBaseInfor.vendorCode = vendorCode;
          this.bidBaseInfor['demanderTel'] = getAssignPhone;
          this.bidSaveData.bidBaseInfor = this.bidBaseInfor;
        }
        else {
          this.bidBaseInfor = historyData['bidBaseInfor'];
          this.bidBaseInfor.formId = formid;
          this.bidBaseInfor.vendorCode = vendorCode;
          this.bidSaveData.bidBaseInfor = this.bidBaseInfor;
        }
        this.bidMaterialList = historyData['bidMaterialList'];
        this.bidMaterialList.formId = formid;
        this.bidMaterialList.vendorCode = vendorCode;
        this.bidSaveData.bidMaterialList = this.bidMaterialList;

        // 遍历历史数据并组成页面呈现的数据listOfBaseMaterialData
        listOfBaseMaterialData = this.getListOfBaseMaterialData(historyData);
      }
      else {
        // 如果没有历史数据
        this.bidBaseInfor['demanderTel'] = getAssignPhone;
        this.bidBaseInfor['monthlyDay'] = '90';
        this.bidSaveData.bidBaseInfor = this.bidBaseInfor;
        this.bidSaveData.bidMaterialList = this.bidMaterialList;
        listOfBaseMaterialData.push(JSON.parse(JSON.stringify(this.table2DataModel)));
      }
    }).catch(e => {
      this.message.create('error', this.translateService.instant('CommonMessageTip.getDataFail'));
    });
    return {
      "bidSaveData": this.bidSaveData,
      "listOfBaseMaterialData": listOfBaseMaterialData,
    };
  }
  // 遍历历史数据并组成页面呈现的数据listOfBaseMaterialData
  getListOfBaseMaterialData(historyData: Array<any>) {
    let bidItemDetailTemp = historyData['bidItemDetail'][0];
    let bidItemKeys = Object.keys(bidItemDetailTemp);
    let bidItemDetail = [];
    // 将大项和小项插入数组中
    for (const eachItemKeys of bidItemKeys) {
      bidItemDetail.push({ "item": eachItemKeys, 'itemDetail': bidItemDetailTemp[eachItemKeys]['itemDetail'] });
    }
    // 遍历大项
    for (const eachItem of bidItemDetail) {
      // 遍历小项
      for (const eachItemDetail of eachItem['itemDetail']) {
        let baseMaterialData = {};
        let itemDetailKeys = Object.keys(eachItemDetail);
        //获取小项中的插入baseMaterialData
        for (const eachItemDetailKeys of itemDetailKeys) {
          if (this.selectColumns.indexOf(eachItemDetailKeys) > -1) {
            baseMaterialData[eachItemDetailKeys] = [eachItemDetail[eachItemDetailKeys]];
          }
        }
        eachItemDetail['baseMaterialData'] = baseMaterialData;
      }
    }
    return bidItemDetail;
  }

  // 保存标单数据
  async saveBid(formid: string, vendorCode: string, listOfBaseMaterialData: Array<any>, bidSaveData: Object) {
    this.bidSaveData = bidSaveData;
    this.bidItem = [];
    this.bidItemDetail = [];
    let isSave = true;//是否符合保存条件:item为必填项
    for (const each of listOfBaseMaterialData) {
      // bidItem
      this.bidItem.push({
        'formId': formid,
        'vendorCode': vendorCode,
        'item': each['item'],
      });
      for (const eachItem of this.bidItem) {
        if (eachItem['item'] === '') {
          isSave = false;
          this.message.create('error', this.translateService.instant('CommonMessageTip.bidCategoryItemTip'));
          break;
        }
      }
      if (isSave) {
        // bidItemDetail
        for (const eachItemDetail of each['itemDetail']) {
          if (eachItemDetail['pn'] === '') {
            isSave = false;
            this.message.create('error', this.translateService.instant('CommonMessageTip.bidmaterialInfoTip'));
            break;
          }
          else {
            eachItemDetail['notInUnitPrice'] = eachItemDetail['notInUnitPrice'].replaceAll(/[^\d.]/g, "");
            let notInTotalPrice = '';
            if (eachItemDetail['quantity'] !== '') {
              let quantity = parseFloat(eachItemDetail['quantity']);
              let notInUnitPrice = parseFloat(eachItemDetail['notInUnitPrice']);
              notInTotalPrice = String(Number((quantity * notInUnitPrice).toFixed(2)));
              eachItemDetail['notInTotalPrice'] = notInTotalPrice;
            }
            this.bidItemDetail[this.bidItemDetail.length] = {
              'formId': formid,
              'vendorCode': vendorCode,
              'item': each['item'],
              'pn': eachItemDetail['pn'],
              'bigType': eachItemDetail['bigType'],
              'middleType': eachItemDetail['middleType'],
              'smallType': eachItemDetail['smallType'],
              'projectName': eachItemDetail['projectName'],
              'brandNative': eachItemDetail['brandNative'],
              'specType': eachItemDetail['specType'],
              'unit': eachItemDetail['unit'],
              'quantity': eachItemDetail['quantity'],
              'notInUnitPrice': eachItemDetail['notInUnitPrice'],
              'notInTotalPrice': eachItemDetail['notInTotalPrice'],
              'remark': 'remark' in eachItemDetail ? eachItemDetail['remark'] : "",
            };
          }
        }
      }

    }
    // 如果符合保存条件
    if (isSave) {
      this.bidSaveData.bidItem = this.bidItem;
      this.bidSaveData.bidItemDetail = this.bidItemDetail;
      // 调用API将数据保存到DB
      let params = {
        formId: formid,
        vendorCode: vendorCode,
        body: this.bidSaveData
      }
      await this.bidBaseInforControllerService.saveBidBaseInformation(params).toPromise().then(result => {
        if (result[0]['success']) {
          this.message.create('success', this.translateService.instant('CommonMessageTip.saveSucceeded'));
          this.submitBidSaveData = JSON.parse(JSON.stringify(this.bidSaveData));//保证每次传给父组件的submitBidSaveData都是有点保存并保存成功后的数据
        } else {
          this.message.create('error', `${this.translateService.instant('CommonMessageTip.saveFailed')}`);
        }
      }).catch(e => {
        this.message.create('error', `${this.translateService.instant('CommonMessageTip.saveFailed')}`);
        this.submitBidSaveData = {};
      });
    }
    return {
      "submitBidSaveData": this.submitBidSaveData,
      "bidSaveData": this.bidSaveData
    };
  }
  // 将标单数据下载至本地
  async downloadBid(bidSaveData: BidSaveData, listOfTable1Data: DataOfTabel1[], listOfBaseMaterialData: Array<any>, step: number, projectCategory?: number) {
    // 标单form-content
    const formContent = BID_FORM_CONTENT;
    const excelData = [];
    const excelName = bidSaveData.bidBaseInfor['projectName'];
    // 数据
    const formLeftData = formContent.slice(0, 7);
    const formMiddleData = formContent.slice(7, 14);
    const formRightData = formContent.slice(14, 15);
    // 标题
    excelData.push([this.translateService.instant('BidCreat.Quotation')]);
    // form信息
    formLeftData.forEach((array, index) => {
      const column2 = bidSaveData.bidBaseInfor[array['value']] === '0' ? null : bidSaveData.bidBaseInfor[array['value']];
      const column4 = bidSaveData.bidBaseInfor[formMiddleData[index]['value']] === '0' ? null : bidSaveData.bidBaseInfor[formMiddleData[index]['value']];
      const column6 = bidSaveData.bidBaseInfor[formRightData[0]['value']] === '0' ? null : bidSaveData.bidBaseInfor[formRightData[0]['value']];
      // form
      excelData.push(
        [
          this.translateService.instant(array['text']) + ':' + column2,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          this.translateService.instant(formMiddleData[index]['text']) + ':' + column4,
          null,
          index === 6 ? this.translateService.instant(formRightData[0]['text']) + ':' + column6 : null,
          null
        ]
      );
    });
    // table1
    excelData.push(
      [
        this.translateService.instant('BidCreat.Item'),
        this.translateService.instant('BidCreat.ProjectName'),
        null,
        null,
        null,
        null,
        this.translateService.instant('BidCreat.Proportion'),
        null,
        this.translateService.instant('BidCreat.Unit'),
        this.translateService.instant('BidCreat.Quantity'),
        this.translateService.instant('BidCreat.TotalPriceWithTax'),
        null,
        this.translateService.instant('BidCreat.Remark'),
      ]
    );

    listOfTable1Data.forEach((array, index) => {
      excelData.push(
        [
          index === 3 ? array['projectName'] : array['id'],
          index === 3 ? null : array['projectName'],
          null,
          null,
          null,
          null,
          !!array['scale'] ? array['scale'] : null,
          null,
          array['unit'],
          array['quantity'],
          projectCategory === 0 ? getHeader6(index, array) : "-",
          null,
          array['remark'],
        ]
      );
    });
    function getHeader6(index: number, array: object) {
      let price = "";
      if (index === 0) {
        price = array['materialCostTotalPrice'];
      }
      else if (index === 1) {
        price = array['profitTotalPrice']
      }
      else {
        price = index === 2 ? array['taxRatesTotalPrice'] : array['table1TotalPrice'];
      }
      return price;
    }

    // table2
    let table2MergesIndex = [];
    excelData.push(
      [
        this.translateService.instant('BidCreat.Item'),
        this.translateService.instant('BidCreat.PN'),
        this.translateService.instant('BidCreat.PrimaryCategory'),
        this.translateService.instant('BidCreat.SecondaryCategory'),
        this.translateService.instant('BidCreat.MinorCategory'),
        this.translateService.instant('BidCreat.ProjectName'),
        this.translateService.instant('BidCreat.BrandOrigin'),
        this.translateService.instant('BidCreat.SpecModel'),
        this.translateService.instant('BidCreat.Unit'),
        this.translateService.instant('BidCreat.Quantity'),
        this.translateService.instant('BidCreat.UntaxedUnitPrice'),
        this.translateService.instant('BidCreat.UntaxedTotalPrice'),
        this.translateService.instant('BidCreat.Remark'),
      ]
    );
    listOfBaseMaterialData.forEach((array, index) => {
      excelData.push(
        [
          array['item']
        ]
      );
      table2MergesIndex.push(excelData.length - 1);
      array['itemDetail'].forEach((detailArray: object, detailIndex: number) => {
        excelData.push(
          [
            String(detailIndex + 1),
            detailArray['pn'],
            detailArray['bigType'],
            detailArray['middleType'],
            detailArray['smallType'],
            detailArray['projectName'],
            detailArray['brandNative'],
            detailArray['specType'],
            detailArray['unit'],
            detailArray['quantity'],
            projectCategory === 0 ? detailArray['notInUnitPrice'] : "-",
            projectCategory === 0 ? detailArray['notInTotalPrice'] : "-",
            detailArray['remark'],
          ]
        );
      })
    });
    // table2-total
    excelData.push(
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        "Total",
        projectCategory === 0 ? listOfTable1Data[0]['materialCostTotalPrice'] : "-",
      ]
    );

    // 备注
    const monthlyDay = step === 5 ? null : bidSaveData.bidBaseInfor.monthlyDay;
    const warrantyPeriod = step === 5 ? null : bidSaveData.bidBaseInfor.warrantyPeriod;
    const deliveryCycle = step === 5 ? null : bidSaveData.bidBaseInfor.deliveryCycle;
    const quoteInday = step === 5 ? null : bidSaveData.bidBaseInfor.quoteInday;
    excelData.push(
      [
        this.translateService.instant('BidCreat.Remark') + ":",
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.translateService.instant('BidCreat.Stamp') + ":"
      ]
    );

    excelData.push(
      [
        this.translateService.instant('BidCreat.Remark1'),
      ],
      [
        `${this.translateService.instant('BidCreat.Remark2-1')}${monthlyDay}${this.translateService.instant('BidCreat.Remark2-2')}`,
      ],
      [
        `${this.translateService.instant('BidCreat.Remark3')}${warrantyPeriod}`
      ],
      [
        `${this.translateService.instant('BidCreat.Remark4')}`
      ],
      [
        `${this.translateService.instant('BidCreat.Remark5-1')}${deliveryCycle}${this.translateService.instant('BidCreat.Remark5-2')}`
      ],
      [
        `${this.translateService.instant('BidCreat.Remark6')}${quoteInday}${this.translateService.instant('BidCreat.Days')}`
      ],
      [
        this.translateService.instant('BidCreat.Remark7')
      ],
      [
        this.translateService.instant('BidCreat.Remark8')
      ],
      [
        this.translateService.instant('BidCreat.Remark8-1')
      ],
      [
        this.translateService.instant('BidCreat.Remark8-2')
      ],
      [
        this.translateService.instant('BidCreat.Remark8-3')
      ],
      [
        this.translateService.instant('BidCreat.Remark8-4')
      ],
      [
        "No.:20190322V1"
      ]
    );
    this.commonService.exportToExcel(excelName, [], excelData, table2MergesIndex);
  }

  async getInitTable1Data(profit: number, taxRates: number, materialCostRemark?: string, profitRemark?: string, taxRatesRemark?: string) {
    this.listOfTable1Data = [
      {
        id: this.translateService.instant('BidCreat.One'),
        projectName: this.translateService.instant('BidCreat.MaterialCosts'),
        scale: "-",
        unit: this.unit,
        quantity: this.quantity,
        materialCostTotalPrice: '',
        remark: materialCostRemark ? materialCostRemark : '',
      },
      {
        id: this.translateService.instant('BidCreat.Two'),
        projectName: this.translateService.instant('BidCreat.ManagementFees'),
        scale: profit >= 0 ? profit + '%' : '13%',
        scaleNumber: profit >= 0 ? profit : 13,
        unit: this.unit,
        quantity: this.quantity,
        profitTotalPrice: '',
        remark: profitRemark ? profitRemark : '',
      },
      {
        id: this.translateService.instant('BidCreat.Three'),
        projectName: this.translateService.instant('BidCreat.TaxRatesTaxes'),
        scale: taxRates >= 0 ? taxRates + '%' : '9%',
        scaleNumber: taxRates >= 0 ? taxRates : 9,
        unit: this.unit,
        quantity: this.quantity,
        taxRatesTotalPrice: '',
        remark: taxRatesRemark ? taxRatesRemark : '',
      },
      {
        projectName: this.translateService.instant('BidCreat.Total'),
        unit: this.totalUnit,
        quantity: '',
        table1TotalPrice: '',
        remark: '',
      }
    ];
    return { "listOfTable1Data": this.listOfTable1Data };
  }

  async getInitTable2Data() {
    let filterData = {};
    await this.baseMaterialListControllerService.findMaterialData({
      dbName: this.dbName,
      body: {
        "where": filterData,
        "columns": this.outputColumns
      }
    }).toPromise().then(res => {
      this.allBaseMaterialData = res;
    });

    this.baseMaterialData = {
      baseMaterialData: this.allBaseMaterialData,
      pn: '',
      bigType: '',
      middleType: '',
      smallType: '',
      projectName: '',
      brandNative: '',
      specType: '',
      unit: '',
      quantity: '',
      notInUnitPrice: '',
      notInTotalPrice: '',
    };
    this.table2DataModel = {
      "item": '',
      "itemDetail": [
        this.baseMaterialData,
        this.baseMaterialData
      ]
    };
    return {
      "baseMaterialData": this.baseMaterialData,
      "allBaseMaterialData": this.allBaseMaterialData,
      "table2DataModel": this.table2DataModel,
    };
  }
}
export interface BidSaveData {
  "bidBaseInfor"?: BidBaseInfo,
  "bidMaterialList"?: BidTotalItem,
  "bidItem"?: BidItem[],
  "bidItemDetail"?: BidItemDetail[],
}
